/* eslint quote-props: "off" */
export default {
  filter: {
    action: {
      submit: 'Filtrar'
    }
  },
  'filter-edit': 'Editar Filtros',
  'filter-title': 'FILTROS',
  'filter-or': 'Qualquer',
  'filter-and': 'Todas',
  'filter-or-detail': 'Qualquer uma das condições deve ser atendida',
  'filter-and-detail': 'Todas as condições devem sem atendidas',
  'filter-label-AND': 'E',
  'filter-label-OR': 'OU',
  'filter-label-column': 'Coluna',
  'filter-label-operation': 'Operação',
  'filter-label-value': 'Valor',
  'filter-label-value-start': 'Val. Início',
  'filter-label-value-end': 'Val. Fim',

  'filter-operation-equal': 'igual a',
  'filter-operation-different': 'diferente de',
  'filter-operation-contains': 'contém',
  'filter-operation-not-contains': 'não contém',
  'filter-operation-less-than': 'menor que',
  'filter-operation-greater-than': 'maior que',
  'filter-operation-between': 'entre',
  'filter-operation-is-blank': 'Em branco',
  'filter-operation-is-present': 'Algum valor',

  'filter-max-size-url': 'Tamanho máxido de filtros foi atingido, por favor remova alguns filtros!',
};
